import { IFocusBehavior } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IFocusBehaviorPropertyEditable {
  focusBehavior(): IPropertyEditable<IFocusBehavior>;
}

export function instanceOfIFocusBehaviorPropertyEditable(instance: any): instance is IFocusBehaviorPropertyEditable {
  return instance
      && instance.focusBehavior
      && instanceOfIPropertyEditable<IFocusBehavior>(instance.focusBehavior());
}
